import { Box, AppBar, Toolbar, Typography, Divider } from '@mui/material';
import IconButton from '@mui/material/IconButton';

import { ReactComponent as ChevronsLeftIcon } from '@/assets/icons/bx-chevrons-left.svg';

type HeaderNaviProps = {
  isSideMenuOpen: boolean;
  onToggleSideMenu: () => void;
};

export const HeaderNavi = ({ isSideMenuOpen, onToggleSideMenu }: HeaderNaviProps) => {
  return (
    <Box>
      <AppBar
        elevation={0}
        sx={{
          backgroundColor: '#FFFFFF',
          color: '#000000',
          width: '100%',
          position: 'static',
        }}
      >
        <Toolbar disableGutters sx={{ height: '68px', paddingLeft: '30px', paddingRight: '20px' }}>
          <IconButton
            aria-label="toggle side menu"
            onClick={onToggleSideMenu}
            sx={{
              width: '36px',
              height: '36px',
              marginRight: '24px',
              padding: 0,
              border: '1px solid #000000',
              borderRadius: '6px',
              background: '#FFFFFF',
              '&:hover': {
                background: '#E5E7EB',
              },
            }}
          >
            <ChevronsLeftIcon
              width="24px"
              height="24px"
              style={{ transform: isSideMenuOpen ? undefined : 'rotate(180deg)' }}
            />
          </IconButton>
          <Typography
            variant="body1"
            component="div"
            sx={{
              flexGrow: 1,
              fontFamily: 'Roboto',
              fontStyle: 'normal',
              fontWeight: 400,
              fontSize: '18px',
              lineHeight: '150%',
              letterSpacing: '0.15px',
            }}
          >
            INFLUFECT 管理画面
          </Typography>
        </Toolbar>
        <Divider sx={{ height: '1px' }} />
      </AppBar>
    </Box>
  );
};
